import styled from "styled-components";

export const ChatModule = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: 0;
`;
